import {
  BellIcon,
  HomeIcon,
  UsersIcon,
  UserGroupIcon,
  CalendarIcon,
  CubeIcon,
  QuestionMarkCircleIcon,
  FolderIcon,
  ChartBarIcon,
  CalendarDaysIcon,
} from '@heroicons/react/24/outline';

export function buildNavigation({ isForecaster }) {
  const forecasterDocsLink = { name: 'Forecaster Docs', href: '/docs/', external: true };
  const docsChildren = isForecaster
    ? [{ ...forecasterDocsLink, name: 'Documentation' }]
    : [
        forecasterDocsLink,
        { name: 'Admin Docs', href: '/admin-documentation', requiredPermission: 'market_owner_read' },
      ];

  return [
    { name: 'Dashboard', href: '/dashboard', icon: HomeIcon, current: true },
    { name: 'Analytics', href: '/analytics', icon: ChartBarIcon, current: false },
    { name: 'Forecasts', href: '/forecasts', icon: CalendarIcon, current: false },
    { name: 'Schedule', href: '/schedule', icon: CalendarDaysIcon, current: false },
    { name: 'Notices', href: '/notices', icon: BellIcon, current: false },
    // hideOnMobile: exports/uploads are a desktop workflow; the phone drawer
    // drops this entry (the route itself stays reachable by URL).
    { name: 'Files', href: '/files', icon: FolderIcon, current: false, hideOnMobile: true },
    {
      name: 'Users',
      icon: UsersIcon,
      current: false,
      requiredPermission: 'market_owner_read',
      flattenLabel: 'Invite',
      children: [
        { name: 'Invite', href: '/users/invite-user', requiredPermission: 'market_owner_read' },
        { name: 'List Users', href: '/users/list-users', requiredPermission: 'admin' },
        { name: 'User Activity', href: '/users/activity', requiredPermission: 'admin' },
      ],
    },
    {
      name: 'Operations',
      icon: CalendarIcon,
      current: false,
      requiredPermission: 'admin',
      children: [
        { name: 'Overview', href: '/operations', requiredPermission: 'admin' },
        { name: 'Challenge Templates', href: '/data/resource/challenge-templates', requiredPermission: 'admin' },
        { name: 'Excluded Days', href: '/operations/excluded-days', requiredPermission: 'admin' },
        { name: 'Notices', href: '/operations/notices', requiredPermission: 'admin' },
        { name: 'Manage Resources', href: '/data/resource', requiredPermission: 'admin' },
      ],
    },
    ...(isForecaster
      ? [{
          name: 'Resources',
          icon: CubeIcon,
          current: false,
          flattenLabel: 'Resources',
          children: [
            { name: 'Manage Resources', href: '/data/resource' },
          ],
        }]
      : []),
    {
      name: 'Forecasters',
      icon: UserGroupIcon,
      current: false,
      requiredPermission: 'market_owner_read',
      flattenLabel: 'Payments',
      children: [
        { name: 'Participants', href: '/data/resource/participants', requiredPermission: 'admin' },
        { name: 'Payments', href: '/users/payments' },
        { name: 'Payment groups', href: '/users/payment-groups', requiredPermission: 'admin' },
        { name: 'Email history', href: '/users/email-history', requiredPermission: 'admin' },
      ],
    },
    {
      name: 'Help',
      icon: QuestionMarkCircleIcon,
      current: false,
      children: [
        ...docsChildren,
        { name: 'Changelog', href: '/changelog' },
        { name: 'FAQ', href: '/faq' },
      ],
    },
  ];
}
